import TimePicker from "react-time-picker"
import Input from "~/components/Input"
import { TextQuestion } from "~/types/questionTypes"
import { parsePlaceholder } from "~/util/parseFieldAnnotations"

type TextFieldProps = {
  value: string | string[]
  question: TextQuestion
  onChange: (newValue: string) => void
  className?: string
}

export const TextField = (props: TextFieldProps): JSX.Element => {
  const {
    fieldAnnotation,
    fieldName,
    textValidationMin,
    textValidationMax,
    textValidationTypeOrShowSliderNumber
  } = props.question
  const { value, onChange } = props

  const minMaxProps = {
    ...(textValidationMin && { min: textValidationMin }),
    ...(textValidationMax && { max: textValidationMax })
  }

  const placeholder = parsePlaceholder(fieldAnnotation)

  if (textValidationTypeOrShowSliderNumber === "time") {
    return (
      <div className="flex flex-col gap-1.5">
        <p>Vælg tidspunkt</p>
        <div className="w-full">
          <TimePicker
            required
            className="w-full h-[50px]"
            name={fieldName}
            value={(value as string) || ""}
            onChange={(newValue) => newValue && onChange(String(newValue))}
            hourPlaceholder="tt"
            minutePlaceholder="mm"
            format="HH:mm"
            disableClock
            clearIcon={null}
          />
        </div>
      </div>
    )
  } else if (textValidationTypeOrShowSliderNumber === "number") {
    return (
      <Input
        required
        placeholder={placeholder}
        type="number"
        step="1"
        name={fieldName}
        value={value || ""}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        {...minMaxProps}
      />
    )
  } else if (textValidationTypeOrShowSliderNumber === "integer") {
    return (
      <Input
        required
        placeholder={placeholder}
        type="number"
        step="1"
        name={fieldName}
        value={value || ""}
        onChange={(event) => {
          onChange(event.target.value)
        }}
        {...minMaxProps}
      />
    )
  } else if (textValidationTypeOrShowSliderNumber === "email") {
    return (
      <Input
        required
        placeholder={placeholder}
        type="email"
        name={fieldName}
        value={value}
        onChange={(event) => {
          onChange(event.target.value)
        }}
      />
    )
  } else {
    return (
      <Input
        required
        placeholder={placeholder}
        type="text"
        name={fieldName}
        value={value || ""}
        onChange={(event) => {
          onChange(event.target.value)
        }}
      />
    )
  }
}
